// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"b66aeb8a","543":"7e7b3c32","615":"6f3c9f6d"}[chunkId] + ".chunk.js";
};